import React from 'react'
import firebase from '../firebase/firebase'
import "firebase/auth";
import {useState, useContext, useEffect, createContext} from 'react';
import {useHistory} from "react-router-dom";

export const Authcontext = createContext()
 const AuthcontextProvider = (props) => {
    let history = useHistory();
    const [User, setUser] = useState(null)
    var provider = new firebase.auth.GoogleAuthProvider();

    async function readSession() {
      const user = await window.sessionStorage.getItem(
        `firebase:authUser:AIzaSyDU6YYhdgvo7NIZV6axg1y8RzGhjnJJ8T8:[DEFAULT]`
      );
      if (user) {
        let User = JSON.parse(user);
         console.log("User Found")
        setUser(User.uid);
          } else {
            // No user is signed in.
            console.log("No User Found")
          }  
    }
  
    
    useEffect(() => {
      const func = async()=>{
         await readSession();
      } 
      func();
      //  firebase.auth().onAuthStateChanged((user)=>{
      //     console.log(user);
      //     console.log("inside useeffect2")
      //     setUser(user.uid)
      //     console.log(User)
      //  })

    }, [])
   const signin = ()=>{
     
    provider.setCustomParameters({
        prompt: 'select_account'
      });

      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(
         firebase.auth().signInWithPopup(provider).then(function(result) {
            var token = result.credential.accessToken;
            var user = result.user;
             setUser(user.uid);
            console.log(token);
            console.log(user.uid);
            history.push("/show");
         }).catch(function(error) {
            var errorCode = error.code;
            var errorMessage = error.message;
              
            console.log(error.code)
         }))
      
}
     const signout= ()=> {
        localStorage.clear();
        firebase.auth().signOut()
         
        .then(function() {
            setUser(null)
           console.log('Signout Succesfull');
           history.push("/");
        }, function(error) {
           console.log('Signout Failed')  
        });}
    return (
        <div>
         <Authcontext.Provider value={{User, signin, signout}}>{props.children}</Authcontext.Provider>
        </div>
    )
}
export default AuthcontextProvider;